import {useRef, useState} from 'react'
import {Col, Form, Input, message, Progress, Row, Select, Upload} from 'antd'
import {InboxOutlined} from '@ant-design/icons'
import ModalSingle from './modalSingle'
import styles from './form.module.less'

const {Option} = Select

function FormComponent(props: any) {
  const {customUpload} = props
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()
  const [modalOption, setModalOption]: any = useState({})
  const [baseInfo, setBaseInfo] = useState<any>({}) //基础数据
  const inputRef = useRef<any>()

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e
    }
    return e && e.fileList.slice(-1)
  }

  const uploadProps = {
    multiple: false,
    showUploadList: false,
    accept: '.xls,.xlsx',
    async beforeUpload(file: any) {
      const type = file.name.split('.').slice(-1).join().toLowerCase()

      const isJpgOrPng = ['xls', 'xlsx'].includes(type)

      const isLt2M = file.size / 1024 / 1024 < 5

      if (!isJpgOrPng) {
        message.error('请上传.xls或.xlsx类的的文件')
        return Upload.LIST_IGNORE
      }

      if (!isLt2M) {
        message.error('上传文件大小不能超过5M')
        return Upload.LIST_IGNORE
      }
      await form.validateFields()
    },

    async customRequest(item: any) {
      const {chargeFlag} = form.getFieldsValue()
      const formData: any = new FormData()
      formData.append('file', item.file)
      const values = {accountId: baseInfo.id, chargeFlag}

      try {
        setLoading(true)
        await customUpload({
          ...values,
          formData,
        })
      } catch (error) {
        // message.error(error.message)
      }
      setTimeout(() => {
        setLoading(false)
      }, 500)
    },
  }
  // 选择客户单选
  const chooseBaseBizOpId = () => {
    setModalOption({
      open: true,
    })
    if (inputRef.current) {
      inputRef.current?.blur()
    }
  }
  const onCloseModal = () => {
    setModalOption({
      open: false,
    })

  }
  const onFinishModal = (rowKeys: any, rows: any) => {
    const formData = {...baseInfo, ...rows[0], keyword: rows?.[0]?.accountName, rowKeys: rowKeys}
    setBaseInfo({...formData})
    form.setFieldsValue({...formData})
  }
  return (
    <div>
      <Form form={form} className={styles.form} layout={'vertical'}>
        <Row gutter={15}>
          <Col span={24}>
            <Form.Item
              label="线索账号"
              name="keyword"
            >
              <Input
                allowClear
                placeholder='线索账号'
                ref={inputRef}
                onClick={() => chooseBaseBizOpId()}
                onChange={(value) => {
                  if (!value?.target?.value) {
                    setBaseInfo({
                      ...baseInfo,
                      id: ''
                    })
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="收费标识" name="chargeFlag">
              <Select placeholder="请选择">
                <Option value="true">是</Option>
                <Option value="false">否</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label="文件">
              <Form.Item
                name="dragger"
                valuePropName="fileList"
                getValueFromEvent={normFile}
                noStyle
              >
                <Upload.Dragger name="file" {...uploadProps}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined/>
                  </p>
                  <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
                  <p className="ant-upload-hint">
                    *支持格式：.xls、.xlsx。值可以为空, 但若要上传请按照规范。
                    <span style={{color: 'red'}}>必填字段: 城市、电话号码</span>
                  </p>
                </Upload.Dragger>
              </Form.Item>
              {loading && <Progress status="active" size="small"/>}
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <ModalSingle option={modalOption} onClose={onCloseModal} onFinish={onFinishModal}/>
    </div>
  )
}

export default FormComponent
